export const HOME = '/'
export const TESTS_LIST = '/tests-list'
export const QUESTIONS = '/questions'
export const COMMON_QUESTIONS = '/common-questions'
export const CONTACT = '/contact'